import React, { FC } from 'react'
import {
  ProductPrice,
  FromPrice,
  hasMultipleVariants,
  isDigitalGiftCard,
} from '@moonpig/web-shared-products'
import { useProductContext } from '../../../contexts/product'
import { ProductModule } from '../types'
import { ProductModuleSection } from '../ProductModuleSection'

export const PriceModule: FC<ProductModule> = props => {
  const [
    {
      product: { variants, masterVariant, category },
    },
  ] = useProductContext()

  const { price, fullPrice, discountedPercentage } = variants[0]
  const masterVariantPrice = masterVariant.price

  if (isDigitalGiftCard(category.department) && hasMultipleVariants(variants)) {
    return null
  }

  return (
    <ProductModuleSection {...props}>
      {hasMultipleVariants(variants) ? (
        <FromPrice
          priceCentAmount={masterVariantPrice.centAmount}
          currencyCode={masterVariantPrice.currencyCode}
          fractionDigits={masterVariantPrice.fractionDigits}
        />
      ) : (
        <ProductPrice
          priceCentAmount={price.centAmount}
          currencyCode={price.currencyCode}
          fractionDigits={price.fractionDigits}
          minimumQuantity={variants[0].minimumQuantity}
          fullPriceCentAmount={fullPrice?.centAmount}
          discountedPercentage={discountedPercentage}
        />
      )}
    </ProductModuleSection>
  )
}
